/** present past medical conditions */
export class PastPresentMedicalConditions {
	/** holds condition id */
	conditionID: number;
	/** holds condition id */
	condition: string;
	/** holds option value */
	optionValue: string;
}

/** medical conditions dto */
export class MedicalConditions {
	/** holds list of conditions */
	medicalDTO: PastPresentMedicalConditions[];
}

/** surgical history modal */
export class SurgicalHistory {
	/** holds ha id */
	healthAssessmentID: number;
	/** holds surgeries value */
	surgeries: string;
}

/** medications modal */
export class Medications {
	/** holds ha id */
	healthAssessmentID: number;
	/** holds medications value */
	medicationList: string;
}

/** allergies modal */
export class Allergies {
	/** holds ha id */
	healthAssessmentID: number;
	/** holds flag whether allergies are present or not */
	haveAllergies: boolean;
	/** holds medication values */
	medication: string;
	/** holds reaction values */
	reaction: string;
}

/** screenings modal */
export class Screenings {
	/** holds ha id */
	healthAssessmentID: number;
	/** holds flag whether user had pap test */
	hadPapTest: boolean;
	/** holds year of pap test */
	yearOfPapTest: string;
	/** holds flag whether user had mammo */
	hadMammography: boolean;
	/** holds year of mammo test */
	yearOfMammography: string;
	/** holds flag whether user had cst */
	hadCst: boolean;
	/** holds year of cst */
	yearOfCst: string;
	/** holds flag whether user had colonoscopy */
	hadColonoscopy: boolean;
	/** holds year of colonoscopy */
	yearOfColonoscopy: string;
	/** holds flag whether user had dexa */
	hadDexa: boolean;
	/** holds year of dexa */
	yearOfDexa: string;
}

export class Vaccinations {
	/** holds ha id */
	healthAssessmentID: number;
	/** holds flag to check if user had flu */
	hadFlu: boolean;
	/** holds date of last flu */
	dateOfLastFlu: string;
	/** holds flag to check if user had hepatitis a */
	hadHepA: boolean;
	/** holds flag to check if user had hepatitis b */
	hadHepB: boolean;
	/** holds flag to check if user had hpv */
	hadHpv: boolean;
	/** holds flag to check if user had mmr */
	hadMmr: boolean;
	/** holds flag to check if user had pneumonia */
	hadPneumonia: boolean;
	/** holds flag to check if user had shingles */
	hadShingles: boolean;
	/** holds flag to check if user had tetanus */
	hadTetanus: boolean;
	/** holds last tetanus year */
	yearLastTetanus: string;
	/** holds flag to check if user had tdap */
	hadTdap: boolean;
	/** holds tdap year */
	yearLastTdap: string;
	/** holds flag to check if user had chicken pox ever */
	everHadChickenpox: boolean;
	/** holds flag to check if user had vaccine for chicken pox */
	hadChickenpoxVaccine: boolean;
}

export class MenHealth {
	/** holds ha id */
	healthAssessmentID: number;
	/** boolean to check if sexually active */
	sexuallyActive: boolean;
	/** boolean to check if user had std */
	hadStd: boolean;
	/** boolean to check if user wants to check for std */
	wantToTestForStd: boolean;
	/** holds sexual option */
	sexualOption: string;
	/** holds std details */
	stdDetails: string;
	/** holds no of partners */
	noOfSexualPartners: string;
	/** holds concerns list */
	concerns: any;
}

export class WomenHealth {
	/** holds ha id */
	healthAssessmentID: number;
	/** boolean for performed self exam or not */
	performSelfExam: boolean;
	/** boolean to check if sexually active */
	sexuallyActive: boolean;
	/** boolean to check if currently pregnant */
	currentlyPregnant: boolean;
	/** boolean to check if in menopause */
	inMenopause: boolean;
	/** boolean to check if user had std */
	hadStd: boolean;
	/** boolean to check if wanted to check for std */
	wantToTestForStd: boolean;
	/** holds sexual options */
	sexualOption: string;
	/** holds std details */
	stdDetails: string;
	/** holds partners count */
	noOfSexualPartners: string;
	/** holds mensuration age */
	menstruationOnsetAge: string;
	/** holds last mensuration date */
	lastMenstrualCycle: string;
	/** holds the age of fist kid */
	ageWhenFirstDelivery: string;
	/** health concerns */
	concerns: any;
}
